import React from 'react'
import {Block, Col, Row} from 'jsxstyle'
import i18n from '../../../../common/i18n'
import {ReactComponent as HandThumbsUpIcon} from '../../../../common/assets/hand-thumbs-up-icon.svg'
import {ReactComponent as HandThumbsDownIcon} from '../../../../common/assets/hand-thumbs-down-icon.svg'

export interface XpertKnowledgeQualityIndicatorProps {
  xpertKnowledgeQualityScore: number
}

const indicatorConfig = [
  {
    condition: (score: number) => score > 0.7,
    icon: <HandThumbsUpIcon width={16} height={16} color="#2D7C35" />,
    title: i18n.t('xk.tutorial.qualityIndicator.excellent.title'),
    titleColor: '#2D7C35',
    description: i18n.t('xk.tutorial.qualityIndicator.excellent.description'),
  },
  {
    condition: (score: number) => score > 0.4 && score <= 0.7,
    icon: <HandThumbsUpIcon width={16} height={16} color="#AD5400" />,
    title: i18n.t('xk.tutorial.qualityIndicator.fair.title'),
    titleColor: '#AD5400',
    description: i18n.t('xk.tutorial.qualityIndicator.fair.description'),
  },
  {
    condition: (score: number) => score <= 0.4,
    icon: <HandThumbsDownIcon width={16} height={16} color="#AB0D0D" />,
    title: i18n.t('xk.tutorial.qualityIndicator.limited.title'),
    titleColor: '#AB0D0D',
    description: i18n.t('xk.tutorial.qualityIndicator.limited.description'),
  },
]

const XpertKnowledgeQualityIndicator: React.FC<XpertKnowledgeQualityIndicatorProps> = ({xpertKnowledgeQualityScore}) => {
  const indicator = indicatorConfig.find((q) => q.condition(xpertKnowledgeQualityScore))
  if (!indicator) return null

  return (
    <Col padding="10px 20px" borderRadius="12px" gap="12px" boxSizing="border-box" backgroundColor="#FFFFFF" border="1px solid #E0E0E0">
      <Col gap="8px">
        <Row gap="8px">
          {indicator.icon}
          <Block
            fontWeight={400}
            fontSize="12px"
            lineHeight="21px"
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            color={indicator.titleColor}
          >
            {indicator.title}
          </Block>
        </Row>
        <Block
          fontWeight={300}
          fontSize="14px"
          lineHeight="22px"
          overflow="hidden"
          whiteSpace="pre-wrap"
          textOverflow="ellipsis"
          color="#5B6071"
          textAlign="justify"
        >
          {indicator.description}
        </Block>
      </Col>
    </Col>
  )
}

export default XpertKnowledgeQualityIndicator
